module.exports = __webpack_public_path__ + "edit.png?f386e22c135e5ecf3acb4dd444c440c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.png
// module id = 245
// module chunks = 0